import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CookieBanner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(33, 33, 33, 0.95);
  color: white;
  padding: 20px;
  display: ${props => props.show ? 'flex' : 'none'};
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const Content = styled.div`
  flex: 1;
  margin-right: 20px;
  
  @media (max-width: 768px) {
    margin-right: 0;
    text-align: center;
  }
`;

const Title = styled.h3`
  margin: 0 0 10px 0;
  font-size: 1.2rem;
  color: #fff;
`;

const Description = styled.p`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #ccc;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const AcceptButton = styled(Button)`
  background: #4CAF50;
  color: white;
  
  &:hover {
    background: #45a049;
  }
`;

const RejectButton = styled(Button)`
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const PrivacyLink = styled.a`
  color: #4CAF50;
  text-decoration: none;
  margin-left: 5px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Here you can initialize your analytics and other tracking scripts
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
    // Here you can disable any tracking scripts
  };

  return (
    <CookieBanner show={showBanner}>
      <Content>
        <Title>We value your privacy</Title>
        <Description>
          We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
          By clicking "Accept", you consent to our use of cookies. Read more about how we use cookies in our
          <PrivacyLink href="/privacy-policy" target="_blank">Privacy Policy</PrivacyLink>.
        </Description>
      </Content>
      <ButtonGroup>
        <RejectButton onClick={handleReject}>
          Reject All
        </RejectButton>
        <AcceptButton onClick={handleAccept}>
          Accept All
        </AcceptButton>
      </ButtonGroup>
    </CookieBanner>
  );
};

export default CookieConsent;
